import React, { CSSProperties, ReactNode, useRef } from 'react';
import * as S from './styles';
import PrintBannersModal from './PrintBannersModal';
import SVG from '../SVG';
import RecoverPasswordModal from './RecoverPasswordModal';
import ConfirmBannerFormsDeletion from './ConfirmBannerFormsDeletion';
import ConfirmSessionModal from './ConfirmSessionModal';
import Export from './Export';
import Validity from './Validity';

export interface ModalProps {
  isOpen: boolean;
  onClose?: () => void;
  children: ReactNode;
  headerTitle?: string;
  height?: CSSProperties['height'];
  width?: CSSProperties['width'];
  alignment?: 'left' | 'center' | 'right';
  backgroundColor?: CSSProperties['backgroundColor'];
  style?: CSSProperties;
}

const Modal = ({
  isOpen,
  onClose,
  children,
  height,
  width,
  headerTitle = '',
  alignment = 'center',
  backgroundColor,
}: ModalProps) => {
  const modalRef = useRef(null);

  const handleOverlayClick = (e: React.MouseEvent<HTMLDivElement>) => {
    if (onClose && modalRef.current === e.target) {
      onClose();
    }
  };

  if (!isOpen) {
    return null;
  }

  return (
    <S.ModalOverlay
      ref={modalRef}
      onMouseDown={handleOverlayClick}
      alignment={alignment}
    >
      <S.ModalContent
        height={height}
        width={width}
        alignment={alignment}
        backgroundColor={backgroundColor}
      >
        {onClose ? (
          <S.ModalCloseButton onClick={onClose}>
            <SVG.Icon.Close width={32} height={32} />
          </S.ModalCloseButton>
        ) : null}
        {headerTitle ? (
          <S.ModalHeader>
            <S.ModalTitle>{headerTitle}</S.ModalTitle>
          </S.ModalHeader>
        ) : null}
        {children}
      </S.ModalContent>
    </S.ModalOverlay>
  );
};

export default Object.assign(Modal, {
  PrintBanners: PrintBannersModal,
  RecoverPassword: RecoverPasswordModal,
  ConfirmBannerFormsDeletion: ConfirmBannerFormsDeletion,
  ConfirmSession: ConfirmSessionModal,
  Export,
  Validity,
});
